<template>
  <div class="relative flex divide-x-2 items-center justify-between p-0.5 m-0 rounded-md shadow-sm">
    <button
      type="button"
      class="relative inline-flex items-center w-full px-2 py-2 text-sm font-semibold text-gray-900 bg-white outline-none rounded-l-md ring-1 ring-inset ring-gray-300 hover:bg-gray-100 focus:z-10"
      @click.stop="
        () => {
          selected_action.onClick()
        }
      ">
      {{ selected_action.name }}
    </button>
    <Menu as="div" class="relative block gap-3 py-0 m-0 pl-0.5 outline-none">
      <MenuButton
        class="relative inline-flex items-center w-full p-2 text-gray-400 bg-white rounded-md ring-1 ring-inset ring-gray-300 hover:bg-gray-200 focus:z-10">
        <span class="sr-only">Open options</span>
        <ChevronDown class="w-5 h-5" aria-hidden="true" />
      </MenuButton>
      <transition
        enter-active-class="transition duration-100 ease-out"
        enter-from-class="transform scale-95 opacity-0"
        enter-to-class="transform scale-100 opacity-100"
        leave-active-class="transition duration-75 ease-in"
        leave-from-class="transform scale-100 opacity-100"
        leave-to-class="transform scale-95 opacity-0">
        <MenuItems
          class="absolute w-[160px] origin-bottom-right bg-white rounded-md shadow-lg -right-1 z-15 mt-2 ring-1 ring-black ring-opacity-5 focus:outline-none">
          <MenuItem
            v-for="action in actions"
            :key="action.name"
            v-slot="{ active }"
            class="w-full px-2 py-3 pl-3 pr-2"
            @click="
              () => {
                selected_action = action
              }
            ">
            <div
              :class="[active ? 'bg-gray-100 text-gray-900' : 'text-gray-700', 'block']"
              class="flex items-center justify-between w-full gap-2">
              <span>{{ action.name }}</span>
              <component :is="action.icon" v-if="action.icon" class="w-5 h-5 test-gray-200" aria-hidden="true" />
            </div>
          </MenuItem>
        </MenuItems>
      </transition>
    </Menu>
  </div>
</template>

<script>
import { Menu, MenuButton, MenuItem, MenuItems } from "@headlessui/vue"
import { ChevronDown } from "lucide-vue-next"

export default {
  components: {
    Menu,
    MenuButton,
    MenuItem,
    MenuItems,
    ChevronDown
  },
  props: {
    actions: {
      type: Array,
      required: true
    },
    defaultActionIndex: {
      type: Number,
      default: 0,
      required: false
    }
  },
  data() {
    return {
      selected_action: {
        name: this.actions[this.defaultActionIndex].name,
        onClick: this.actions[this.defaultActionIndex].onClick
      }
    }
  }
}
</script>
